import MUICard, { CardProps as MUICardProps } from '@mui/material/Card';
import MUICardContent, {
  CardContentProps as MUICardContentProps
} from '@mui/material/CardContent';
import React from 'react';

export type CardProps = MUICardProps;

/** Extension of [Material-UI Card](https://mui.com/material-ui/react-card/) - [Api](https://mui.com/material-ui/api/card/)
 *
 * The Card component is a container for content and actions about a single subject.
 */
export const Card = ({ children, ...props }: CardProps) => {
  return <MUICard {...props}>{children}</MUICard>;
};

export type CardContentProps = MUICardContentProps;

/** Extension of [Material-UI CardContent](https://mui.com/material-ui/react-card/) - [Api](https://mui.com/material-ui/api/card-content/)
 *
 * The CardContent component is used to display the main content of a card.
 */
export const CardContent = ({ children, ...props }: CardContentProps) => {
  return <MUICardContent {...props}>{children}</MUICardContent>;
};
